<template>
  <!-- 邓智轩：寻道大千及ROV游戏内第三方支付优化，特殊样式 -->
  <div
    class="third-way pay-way-xddq"
    :class="[classes, pointClass, `pay-way-xddq-${gameId}`, pageLanguage]"
    @click="passMethod('click')"
    v-if="isXddq"
  ></div>
  <div
    class="third-way pay-way-common"
    :class="[classes, pointClass, pageLanguage]"
    @click="passMethod('click')"
    v-else-if="
      isRov ||
      isMuglo ||
      isDzg ||
      isDlssr ||
      isDl3dvn ||
      isZtmslgme ||
      isZljslg ||
      isBeast ||
      isLooteu ||
      isSlmmo ||
      isLootkr ||
      isAntslg ||
      isTmslg ||
      isDtmslg
    "
  ></div>
  <div
    v-else
    class="third-way pay-way blue"
    :class="[classes, pointClass]"
    @click="passMethod('click')"
  >
    <StoreLogo
      class="brand"
      :class="$platformClass"
      :mystyle="storeIconStyle"
      :src="brandTextUrl"
      :style="showLogo ? '' : 'opacity: 0;'"
    ></StoreLogo>
    <p
      class="discount"
      :class="[!laddingFinish ? 'loaddingInitData' : false, $platformClass]"
    >
      <Icon type="thirdPartNameIconLeft"></Icon>
      <Mark type="thirdPartName" :class="showSpecTTH ? 'bold-font' : false">
        {{ languages.storeHoaveReward }}
      </Mark>
      <Icon type="thirdPartNameIconRight"></Icon>
    </p>
    <Button class="pay-btn" type="selectPayType" :style="buttonStyle">
      {{ languages.payBtnText }}
      <Icon v-if="!$isOmni" type="selectThirPay"></Icon>
    </Button>
    <p
      class="discoun-tips"
      :class="$platformClass"
      v-if="!hideThirdWayTips"
      :style="[isDl3dvnGame ? { width: '640px' } : {}]"
    >
      <span class="content" v-if="!isFuntapGame">
        {{ notFuntapGameOfTip }}
      </span>
      <span class="content" v-if="isFuntapGame">
        Tặng thêm {{ funtapGameRate }} Kim cương
      </span>
      <!-- <i class="bg"></i> -->
      <Icon type="discountTipsIconBg" class="bg"></Icon>
      <Icon type="discountTipsIcon"></Icon>
    </p>
    <StoreLogo
      v-if="showSpecTTH"
      class="spec-logo"
      :src="specTTHUrl"
    ></StoreLogo>
  </div>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
import globalConfig from '../../../utiles/globalConfig';
export default {
  mixins: [themeMixins],
  props: [
    'laddingFinish',
    'languages',
    'brandTextUrl',
    'gymcGame',
    'brandTextVisibility',
    'brandTextMarginTop',
    'brandTextMarginBottom',
    'showSpecTTH',
    'isFuntapGame',
    'isDl3dvnGame',
    'isXddq',
    'isRov',
    'isZljslg',
    'isZtmslgme',
    'isMuglo',
    'isBeast',
    'isDlssr',
    'isDl3dvn',
    'isDzg',
    'isLooteu',
    'isSlmmo',
    'isLootkr',
    'isAntslg',
    'isTmslg',
    'isDtmslg',
    'hideThirdWayTips',
    'gameId',
    'showLogo'
  ],

  computed: {
    storeIconStyle() {
      let obj = {
        background: 'url(' + this.brandTextUrl + ')',
        visibility: this.brandTextVisibility
      };
      if (this.showSpecTTH) {
        obj = {
          ...obj,
          backgroundSize: '100% 100%',
          marginBottom: '20px',
          marginLeft: '-16px'
        };
      } else {
        obj = {
          ...obj,
          height: 'auto',
          width: 'auto'
        };
      }
      return obj;
    },
    specTTHUrl() {
      if (this.showSpecTTH) {
        return this.brandTextUrl.replace('ynrlwj', atob('dHRoZ2FtZS5jb20='));
      }
      return '';
    },
    buttonStyle() {
      let style = '';
      if (this.showSpecTTH) {
        style = 'margin-top: 30px;';
      }
      return style;
    },
    funtapGameRate() {
      let gameId = +this.gameId;
      const gameRateMap = {
        195: '8~10%',
        221: '10%'
      };
      if (gameId && gameRateMap[gameId]) {
        return gameRateMap[gameId];
      }
      return '5%';
    },
    isAntVnGame() {
      return +this.gameId === 288;
    },
    pageLanguage() {
      const LANGUAGE =
        globalConfig.getHrefParam('appLanguage') ||
        globalConfig.getHrefParam('language');
      return LANGUAGE;
    },
    notFuntapGameOfTip() {
      if (this.isDl3dvnGame) {
        return 'Tặng thêm Kim Cương lên tới 20%';
      }

      if (this.isAntVnGame) {
        return 'Tặng thêm 10%, Ko Mất Phí';
      }

      return this.languages.payReward;
    }
  }
};
</script>
